// Copyright (c) 2020 Deere & Company

import './index.scss';

import AuthenticatedPage from '../../common/components/authenticated-page';
import FamilyCountingBundleGroupAvailability from './family-counting-bundle-group-availability';
import React from 'react';

function FamilyCountingBundleGroupAvailabilityPage () {

    return (
        <AuthenticatedPage className="atp-page atp-family-counting-bundle-group-availability-page">
            <FamilyCountingBundleGroupAvailability />
        </AuthenticatedPage>
    );

}
FamilyCountingBundleGroupAvailabilityPage.displayNAme = 'FamilyCountingBundleGroupAvailabilityPage';

export default FamilyCountingBundleGroupAvailabilityPage;
